import { useNavigate } from 'react-router-dom';
import UserRole from '../../../shared/AuthRoles';
import React, { useEffect } from 'react';
import Notifications from '../../components/Notifications/Notifications';
import ContractorNotifications from '../../components/Notifications/ContractorNotifications';

const NotificationsPage = () => {
    const loggedInUser = UserRole();
    const navigate = useNavigate();

    useEffect(() => {
        if (loggedInUser?.role === 'admin') {
            navigate(`/permissionDenied`, {
                state: {
                    name: 'notificationsPage',
                },
            });
        }
    }, [loggedInUser.role]);

    return loggedInUser?.role.includes('contractor') ? (
        <ContractorNotifications />
    ) : (
        <Notifications />
    );
};

export default NotificationsPage;
